module.exports = __webpack_public_path__ + "static/img/przybornik_kosz.1825ad8c.png";